import React from 'react';

import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { ReleaseStore } from '@common/types/release/release-store';
import { ReleaseListSummary } from '@common/types/release/release-list-summary';

import AppState from '@webapp/store/state';

import TakedownSubmit from './takedown-submit';
import TakedownSuccess from './takedown-success';

interface TakedownReleaseProps {
  summary: Partial<ReleaseListSummary>;
}

const mapStateToProps = (state: AppState) => ({
  summary: state.release.summary,
});

export const TakedownRelease = (props: TakedownReleaseProps) => {
  const [activeStore, setActiveStore] = React.useState<ReleaseStore[]>([]);
  const [tracks, setTracks] = React.useState<
    { number: number; name: string }[]
  >([]);
  const [submitted, setSubmitted] = React.useState<boolean>(false);
  const [releaseTitle, setReleaseTitle] = React.useState<string>('');
  const [releaseCover, setReleaseCover] = React.useState<string>('');

  const match = useRouteMatch<{ releaseId: string; artistId: string }>();
  const releaseId = match.params.releaseId;
  const artistId = match.params.artistId;
  const { summary } = props;

  // TODO: DEVTEAM-603 - isNFT needs to be integrated to know if the takedown is for an NFT item.
  const isNFT = false;

  React.useEffect(() => {
    if (summary?.all?.list) {
      summary.all.list.forEach((release) =>
        release.id === releaseId
          ? (setReleaseTitle(release.title),
            setReleaseCover(release.cover.url),
            setTracks(
              release.tracks?.map((t, i) => {
                return { number: i, name: t.title };
              }) || []
            ))
          : null
      );
    }
  }, [releaseId, summary]);

  if (submitted) {
    return (
      <TakedownSuccess
        releaseTitle={releaseTitle}
        activeStore={activeStore}
        isNFT={isNFT}
      />
    );
  }

  return (
    <TakedownSubmit
      setSubmitted={setSubmitted}
      releaseTitle={releaseTitle}
      releaseCover={releaseCover}
      artistId={artistId}
      releaseId={releaseId}
      isNFT={isNFT}
      tracks={tracks}
      activeStore={activeStore}
      setActiveStore={setActiveStore}
    />
  );
};

export default connect(mapStateToProps)(TakedownRelease);
